import { Currency, type BidDto, type EventValueDto } from "../../../../../autogen/bff-api";
import { productBidTotal, type PricedProductGroup } from "../../../../../common/products/productBidTotal";

export const readonlyTotalPrice = (
  productGroups: PricedProductGroup[],
  bid: Pick<BidDto, "price" | "products">,
  tenderCurrency: Currency | undefined,
): EventValueDto | null | undefined => {
  if (productGroups.length === 0) return bid.price;
  const total = productBidTotal(productGroups, bid.products);
  return total != null ? { value: total, currency: tenderCurrency ?? Currency.Nok } : null;
};
